import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Kick-Off with Project Idea",
    description:
      "Evaluate project scope and set objectives with expert consultation.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Decide Tech Stack",
    description: "Move forward, right and quick, with useful-only resources.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Design",
    description:
      "Create an appealing, intuitive interface with our UI/UX experts.",
    count: "03",
  },
  {
    logo: LaunchIcon,
    title: "Develop",
    description:
      "Code to add functionality and backend features with pro developers.",
    count: "04",
  },
  {
    logo: TestIcon,
    title: "Test",
    description: "Test, debug, and repeat until its launch-ready.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Launch & Maintain",
    description: "Go live and reach users. Adapt as you go.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our Simple, Frictionless Web Development <span>Workflow</span>
            </h2>
            <p>
              We use lean, agile methodology for collaborative development and
              faster turnarounds. Join the ranks of the 100s of companies we
              helped with our optimized and result-driven web development
              process.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-5"
          >
            <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk To Our Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
